import { GoogleReCaptchaEnvironment } from '@qaroni-env/environment';

export const GoogleReCaptchaEnv = {
  scriptSrc:
    'https://www.google.com/recaptcha/api.js?onload=gReCaptchaOnLoadCallback&amp;render=explicit&hl=es',
  sitekey: Object.prototype.hasOwnProperty.call(
    GoogleReCaptchaEnvironment,
    'sitekey'
  )
    ? GoogleReCaptchaEnvironment.sitekey
    : null,
};
